import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc'
import { Button } from 'antd'
import { ExclamationCircleOutlined, LoginOutlined } from '@ant-design/icons'
import { AppState } from '../../stores/app'
import { AuthService } from '../../services/auth'
import './session-expiration-screen.scss'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'

export const SessionExpirationScreen: React.FC<{}> = observer(() => {
    const appState = Container.get(AppState)
    const appSvc = useService(AppService)
    const authService = Container.get(AuthService)

    const visible = appState.isAuthenticated && (appSvc.sessionExpired || appState.sessionExpired)

    const handleSignIn = () => {
        try {
            // Trigger logout which will redirect to Auth0 login
            authService.logout(true)
        } catch (error) {
            console.error('Error during sign-in redirect:', error)
        }
    }

    if (!visible) {
        return null
    }

    return (
        <div className="session-expiration-screen">
            <div className="session-expiration-screen-overlay">
                <div className="session-expiration-screen-content">
                    <div className="session-expiration-screen-header">
                        <ExclamationCircleOutlined className="session-expiration-screen-icon" />
                        <h1 className="session-expiration-screen-title">Session Expired</h1>
                    </div>

                    <div className="session-expiration-screen-message">
                        <p className="session-expiration-screen-primary-message">
                            Your session has expired for security reasons.
                        </p>
                        <p className="session-expiration-screen-secondary-message">
                            Please sign in again to continue using the application.
                        </p>
                    </div>

                    <div className="session-expiration-screen-actions">
                        <Button
                            type="primary"
                            size="large"
                            icon={<LoginOutlined />}
                            onClick={handleSignIn}
                            className="session-expiration-screen-signin-button"
                        >
                            Sign In
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
})
